import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Barcode, Hash, Search, AlertCircle, Disc3 } from 'lucide-react';
import BarcodeScanner from './BarcodeScanner';
import CatalogSearch from './CatalogSearch';
import ManualSearch from './ManualSearch';
import MatrixSearch from './MatrixSearch';

export default function AddAlbumModal({ open, onClose, onSuccess, discogsConnected = true }) {
  const [activeTab, setActiveTab] = useState('barcode');

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl bg-card border-border max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl">Add Album</DialogTitle>
          <DialogDescription>
            Search for your vinyl using one of the methods below
          </DialogDescription>
        </DialogHeader>

        {!discogsConnected && (
          <Alert variant="destructive" className="mt-2">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
              Discogs is not connected. Configure DISCOGS_TOKEN in backend.
            </AlertDescription>
          </Alert>
        )}

        <Tabs value={activeTab} onValueChange={setActiveTab} className="mt-4">
          <TabsList className="grid grid-cols-4 bg-secondary">
            <TabsTrigger value="barcode" className="gap-1.5 text-xs md:text-sm px-2" data-testid="tab-barcode" disabled={!discogsConnected}>
              <Barcode className="w-4 h-4" />
              <span className="hidden md:inline">Barcode</span>
            </TabsTrigger>
            <TabsTrigger value="catalog" className="gap-1.5 text-xs md:text-sm px-2" data-testid="tab-catalog" disabled={!discogsConnected}>
              <Hash className="w-4 h-4" />
              <span className="hidden md:inline">Catalog</span>
            </TabsTrigger>
            <TabsTrigger value="matrix" className="gap-1.5 text-xs md:text-sm px-2" data-testid="tab-matrix" disabled={!discogsConnected}>
              <Disc3 className="w-4 h-4" />
              <span className="hidden md:inline">Pressing</span>
            </TabsTrigger>
            <TabsTrigger value="search" className="gap-1.5 text-xs md:text-sm px-2" data-testid="tab-search" disabled={!discogsConnected}>
              <Search className="w-4 h-4" />
              <span className="hidden md:inline">Search</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="barcode" className="mt-4">
            <BarcodeScanner onSuccess={onSuccess} />
          </TabsContent>

          <TabsContent value="catalog" className="mt-4">
            <CatalogSearch onSuccess={onSuccess} />
          </TabsContent>

          <TabsContent value="matrix" className="mt-4">
            <MatrixSearch onSuccess={onSuccess} />
          </TabsContent>

          <TabsContent value="search" className="mt-4">
            <ManualSearch onSuccess={onSuccess} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
